<script>
import ServidorDependentes from '@/components/shared/servidor/ServidorDependentes.vue'

export default {
  extends: ServidorDependentes,
}
</script>
